import Vue from 'vue';
import { Toast } from 'vant';
import JSEncrypt from 'jsencrypt';

Vue.use(Toast);

export function pxTovw(px) {
  return px / 750 * window.innerWidth;
}

export function getNowTime() {
  let date = new Date();
  let year = date.getFullYear();
  let m = date.getMonth() + 1;
  let month = m < 10 ? '0' + m : m;
  let d = date.getDate();
  let day = d < 10 ? '0' + d : d;
  let h = date.getHours();
  let hour = h < 10 ? '0' + h : h;
  let minu = date.getMinutes();
  let minute = minu < 10 ? '0' + minu : minu;
  let s = date.getSeconds();
  let second = s < 10 ? '0' + s : s;
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
}

export async function urlTogetCampusCode() {
  if (window.location.href.indexOf('code=') > -1 && window.location.href.indexOf('/order/wechatPay') === -1) {
    this.isGetXcode = true;
    let code = window.location.href.split('code=')[1].split('&')[0];
    await this.$store.dispatch('GetXCode', code).then(res => {
      if (res.data.id) {
        let id = res.data.id;
        localStorage.setItem('xsid', id);
      }
    }).catch(() => {
      Toast('The campus does not exist. Redirecting to the main campus');
      setTimeout(() => {
        location.href = '/course/index';
      }, 2000);
    });
  }
}

export function deepClone(target) {
  // 定义一个变量
  let result;
  // 如果当前需要深拷贝的是一个对象的话
  if (typeof target === 'object') {
    // 如果是一个数组的话
    if (Array.isArray(target)) {
      result = []; // 将result赋值为一个数组，并且执行遍历
      for (let i in target) {
        // 递归克隆数组中的每一项
        result.push(deepClone(target[i]));
      }
      // 判断如果当前的值是null的话；直接赋值为null
    } else if (target === null) {
      result = null;
      // 判断如果当前的值是一个RegExp对象的话，直接赋值
    } else if (target.constructor === RegExp) {
      result = target;
    } else {
      // 否则是普通对象，直接for in循环，递归赋值对象的所有值
      result = {};
      for (let i in target) {
        result[i] = deepClone(target[i]);
      }
    }
    // 如果不是对象的话，就是基本数据类型，那么直接赋值
  } else {
    result = target;
  }
  // 返回最终结果
  return result;
}

// es6数组去重
export function uniqueArray(arr) {
  // Set数据结构，它类似于数组，其成员的值都是唯一的
  return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
}

export function encrypt(value) {
  const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnXnrmnWtxXQLC9i4CluYFlD0Nv55VM392dzQwLT23E7MYX63Af2nie2iY0uyDYWlXkqs8Z78TWLhv1gLjghGUsYffszKZ8Uoxxm4oGrN5NVANUa50u2xoVQPrquoEazHxfVs8zbKakVcvRbPvonSP0mOzhbnJBn6XNeGMwbS2fMsQR9vBA7zew4lXJR6aOcx3Z8ofll6XQ5q3mEzViNWpFhZjzpYGg7z8lXkeR3X6sXxLE1MDHh/IkV/g5g9AkzJ0Ea+MQuhANFMiAKJZ0vxxIJiIf/I8WoXbjOv0+atatgjI0AoC/quwR3bD2rNNdMCD13seY54UaUVcXXrlJOq2QIDAQAB';
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKey);
  return encrypt.encrypt(value);
}

// 下载文件
export function downloadFile(url, filename) {
  let xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function() {
    if (xhr.status === 200) {
      let blob = xhr.response;
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.href = window.URL.createObjectURL(blob);
      a.download = filename;
      a.click();
      document.body.removeChild(a);
    }
  };
  xhr.send();
}



// WEBPACK FOOTER //
// ./src/utils/util.js